export const formatStatisticsScore = (score: string): number => {
  if (!score) {
    return 0
  }
  return Math.round((Number(score) + Number.EPSILON) * 100) / 100
}
